export default __webpack_public_path__ + "static/media/botoes_laterais_03.37043792.mp3";